import { useNavigate } from "react-router-dom";
import ChoosePinView from "./view";

export default function ChoosePin() {
  const navigate = useNavigate();

  const goBack = () => navigate(-1);

  const goToPin = (type: "email" | "phone") => {

    navigate('/register/pin/' + type);
  }

  return (
    <ChoosePinView 
      goBack={goBack}
      goToPin={goToPin}
    />
  );
}
